export enum Groups {
  crew_automated_credentials = 1,
  external_email_integration,
  mga,
  pms,
  onboard_sync,
  accounting,
  invoices,
  forms,
  manuals_export,
  evaluations_settings,
  itinerary_onboard,
  purchasing,
  captain_reports
}

type ItemType<T> = { label: string; value: T } | T | null;

export const formatBooleanSelectorValue = <T extends string | number>(
  item: ItemType<T> | number
): T | number | null => (item && typeof item === 'object' && 'value' in item ? item.value : item);
